import type { Bilingual } from '../lib/LanguageContext';

export interface BrandingCopy {
  title: Bilingual;
  tagline: Bilingual;
}

export const brandingCopy: BrandingCopy = {
  title: {
    id: 'TSL Learning Portal',
    ar: 'بوابة التعلّم',
  },
  tagline: {
    id: 'Mempelajari dasar-dasar Islam secara bertahap, mudah, dan fleksibel.',
    ar: 'تعلم أساسيات الإسلام بشكل تدريجي وسهل ومرن.',
  },
};

export const copy = {
  common: {
    loading: { id: 'Memuat...', ar: 'جاري التحميل...' },
    cancel: { id: 'Batal', ar: 'إلغاء' },
    save: { id: 'Simpan', ar: 'حفظ' },
    error: { id: 'Terjadi Kesalahan', ar: 'حدث خطأ' },
    status: { id: 'Status', ar: 'الحالة' },
    code: { id: 'Kode', ar: 'الرمز' },
    back: { id: 'Kembali', ar: 'العودة' },
    next: { id: 'Selanjutnya', ar: 'التالي' },
    submit: { id: 'Kirim', ar: 'إرسال' },
    success: { id: 'Berhasil', ar: 'نجاح' },
    close: { id: 'Tutup', ar: 'إغلاق' },
    pending: { id: 'Tertunda', ar: 'قيد الانتظار' },
    noDescription: { id: 'Tidak ada deskripsi', ar: 'لا يوجد وصف' },
    minutes: { id: 'Menit', ar: 'دقائق' },
    tbd: { id: 'Segera Diumumkan', ar: 'يُحدد لاحقاً' },
    notSet: { id: 'Belum diatur', ar: 'لم يتم الضبط' },
    na: { id: 'Tidak Ada', ar: 'غير متوفر' },
    programFallback: { id: 'Program', ar: 'البرنامج' },
    generalFallback: { id: 'Umum', ar: 'عام' },
    registrationStatus: {
      PENDING: { id: 'Menunggu Verifikasi', ar: 'قيد الانتظار' },
      APPROVED: { id: 'Disetujui', ar: 'مقبول' },
      REJECTED: { id: 'Ditolak', ar: 'مرفوض' },
      REVISION: { id: 'Perlu Revisi', ar: 'بحاجة للمراجعة' },
      CANCELLED: { id: 'Dibatalkan', ar: 'ملغي' },
    },
    enrollmentStatus: {
      ACTIVE: { id: 'Aktif', ar: 'نشط' },
      COMPLETED: { id: 'Selesai', ar: 'مكتمل' },
    },
    downloadReceipt: { id: 'Unduh Bukti Pendaftaran', ar: 'تنزيل إيصال التسجيل' },
    changePasswordSuccess: { id: 'Password berhasil diubah!', ar: 'تم تغيير كلمة المرور بنجاح!' },
  },
  shell: {
    dashboard: { id: 'Dashboard', ar: 'لوحة القيادة' },
    myPrograms: { id: 'Program Saya', ar: 'برامجي' },
    results: { id: 'Hasil Belajar', ar: 'النتائج' },
    logout: { id: 'Keluar', ar: 'تسجيل الخروج' },
    profile: { id: 'Profil', ar: 'الملف الشخصي' },
    notifications: { id: 'Notifikasi', ar: 'الإشعارات' },
    student: { id: 'Peserta', ar: 'مشارك' },
    transcripts: { id: 'Transkrip v3', ar: 'كشف درجات v3' },
    legacyTranscripts: { id: 'Riwayat', ar: 'الأرشيف' },
    more: { id: 'Lainnya', ar: 'المزيد' },
    certificates: { id: 'Syahadah', ar: 'الشهادات' },
    announcements: { id: 'Pengumuman', ar: 'الإعلانات' },
  },
  announcements: {
    title: { id: 'Pengumuman & Informasi', ar: 'الإعلانات والمعلومات' },
    subtitle: {
      id: 'Informasi akademik terkini, jadwal kegiatan, dan pengumuman penting.',
      ar: 'آخر المعلومات الأكاديمية وجداول الفعاليات والإعلانات الهامة.',
    },
    latestAnnouncements: { id: 'Pengumuman & Informasi', ar: 'الإعلانات والبيانات' },
    urgentNotice: { id: 'PENGUMUMAN PENTING', ar: 'تنبيه عاجل' },
    readMore: { id: 'Baca Selengkapnya', ar: 'قراءة المزيد' },
    viewAll: { id: 'Lihat Semua Pengumuman', ar: 'عرض جميع الإعلانات' },
    dismissBanner: { id: 'Tutup Pengumuman', ar: 'إغلاق الإشعار' },
    dismissNotice: { id: 'Tutup Pengumuman', ar: 'إغلاق الإشعار' },
    noAnnouncements: { id: 'Belum ada pengumuman saat ini.', ar: 'لا توجد إعلانات حالياً.' },
    notificationsTitle: { id: 'Pemberitahuan & Siaran', ar: 'الإشعارات والإعلانات' },
    noNotifications: { id: 'Tidak ada pengumuman baru.', ar: 'لا توجد إعلانات جديدة حالياً.' },
    catGeneral: { id: 'Umum', ar: 'عام' },
    catAcademic: { id: 'Akademik', ar: 'أكاديمي' },
    catMaintenance: { id: 'Pemeliharaan', ar: 'صيانة' },
    catImportant: { id: 'Penting', ar: 'هام' },
    catEvent: { id: 'Kegiatan', ar: 'فعالية' },
    prioNormal: { id: 'Normal', ar: 'عادي' },
    prioHigh: { id: 'Tinggi', ar: 'مرتفع' },
    prioUrgent: { id: 'Mendesak', ar: 'عاجل' },
  },
  // Bilingual copy shown by the `LogoutReasonBanner` component on the
  // login / reset-password / verify-email screens when a 401 reason has
  // been stashed into sessionStorage by the api-client's `on401`
  // handler. Keys must match `LogoutReasonKey` in
  // `../lib/logout-reason.ts`.
  loginBanner: {
    account_inactive: {
      id: 'Akun Anda tidak aktif. Silakan hubungi admin untuk mengaktifkannya kembali.',
      ar: 'حسابك غير نشط. يرجى التواصل مع المسؤول لإعادة التفعيل.',
    },
    token_invalid: {
      id: 'Sesi Anda tidak valid. Silakan masuk kembali.',
      ar: 'جلستك غير صالحة. يرجى تسجيل الدخول مرة أخرى.',
    },
    session_expired: {
      id: 'Sesi Anda telah berakhir. Silakan masuk kembali untuk melanjutkan.',
      ar: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى للمتابعة.',
    },
    idle_timeout: {
      id: 'Sesi Anda telah berakhir otomatis karena tidak ada aktivitas untuk menghemat sumber daya server. Silakan masuk kembali.',
      ar: 'انتهت صلاحية جلستك تلقائيًا بسبب عدم وجود نشاط لتوفير موارد الخادم. يرجى تسجيل الدخول مرة أخرى.',
    },
    unknown: {
      id: 'Anda telah keluar dari sesi. Silakan masuk kembali untuk melanjutkan.',
      ar: 'تم تسجيل خروجك. يرجى تسجيل الدخول مرة أخرى للمتابعة.',
    },
  },
  login: {
    title: {
      id: "Assalamu'alaikum, siap untuk belajar?",
      ar: 'السلام عليكم، هل أنت مستعد للتعلم؟',
    },
    subtitle: {
      id: 'Akses portal peserta untuk mengelola program belajar dan memantau kemajuan Anda.',
      ar: 'الدخول إلى بوابة المشاركين لإدارة البرامج الدراسية ومتابعة تقدمك.',
    },
    resetTitle: { id: 'Reset Kata Sandi Anda', ar: 'إعادة تعيين كلمة المرور' },
    resetSubtitle: {
      id: 'Masukkan email Anda untuk menerima tautan pemulihan.',
      ar: 'أدخل بريدك الإلكتروني لتلقي رابط الاسترداد.',
    },
    emailLabel: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    emailPlaceholder: { id: 'peserta@tslearning.com', ar: 'student@tslearning.com' },
    emailInvalid: {
      id: 'Masukkan alamat email yang valid.',
      ar: 'أدخل عنوان بريد إلكتروني صالحًا.',
    },
    identifierRequired: {
      id: 'Email, NIP, atau nomor HP wajib diisi.',
      ar: 'البريد أو الرقم الأكاديمي أو رقم الهاتف مطلوب.',
    },
    passwordRequired: { id: 'Kata sandi wajib diisi.', ar: 'كلمة المرور مطلوبة.' },
    passwordLabel: { id: 'Kata Sandi', ar: 'كلمة المرور' },
    passwordPlaceholder: { id: '••••••••', ar: '••••••••' },
    identifierLabel: { id: 'Email / NIP / No. HP', ar: 'البريد / الرقم الوظيفي / الهاتف' },
    identifierPlaceholder: {
      id: 'email@domain.com, 1985xxxx, atau 0812...',
      ar: 'email@domain.com، 1985xxxx، أو 0812...',
    },
    forgotLabel: { id: 'Lupa Kata Sandi?', ar: 'نسيت كلمة المرور؟' },
    sendLink: { id: 'Kirim Tautan Pemulihan', ar: 'إرسال رابط الاسترداد' },
    signInBtn: { id: 'Masuk ke Portal', ar: 'تسجيل الدخول إلى البوابة' },
    backToLogin: { id: 'Kembali ke Halaman Masuk', ar: 'العودة إلى تسجيل الدخول' },
    notRegistered: { id: 'Belum terdaftar atau sebagai admin?', ar: 'غير مسجل بعد أو كمسؤول?' },
    createAccount: { id: 'Buat akun baru', ar: 'إنشاء حساب جديد' },
    heroTitle: {
      id: 'Tuntutlah Ilmu dengan Keikhlasan dan Keistiqomahan.',
      ar: 'اطلب العلم بإخلاص وتميز.',
    },
    heroText: {
      id: 'Melanjutkan perjalanan menuntut ilmu Anda. Platform kami menyediakan sarana dan komunitas untuk pemahaman yang mendalam dan pertumbuhan keimanan.',
      ar: 'واصل رحلتك التعليمية. توفر منصتنا الأدوات والمجتمع للفهم العميق والنمو الروحي.',
    },
    heroStats: {
      id: 'Gabung bersama 5.000+ peserta aktif di seluruh dunia.',
      ar: 'انضم إلى أكثر من 5000 مشارك نشط حول العالم.',
    },
    linkSentSuccess: {
      id: 'Tautan reset kata sandi telah dikirim ke email Anda.',
      ar: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
    },
    authFailed: {
      id: 'Autentikasi gagal. Silakan periksa kembali email dan kata sandi Anda.',
      ar: 'فشلت عملية المصادقة. يرجى التحقق من البريد الإلكتروني وكلمة المرور.',
    },
    tooManyAttempts: {
      id: 'Terlalu banyak percobaan untuk akun ini. Tunggu satu menit, lalu coba kembali.',
      ar: 'هناك محاولات كثيرة لهذا الحساب. انتظر دقيقة واحدة ثم حاول مرة أخرى.',
    },
    migrationVerificationRequired: {
      id: 'Akun Anda telah dipindahkan ke sistem login baru. Periksa email untuk verifikasi, lalu masuk kembali.',
      ar: 'تم نقل حسابك إلى نظام تسجيل الدخول الجديد. يرجى التحقق من بريدك الإلكتروني ثم تسجيل الدخول مرة أخرى.',
    },
  },
  signup: {
    title: { id: 'Mulai Menuntut Ilmu', ar: 'ابدأ رحلتك التعليمية' },
    subtitle: {
      id: 'Buat akun peserta baru untuk bergabung dengan program Belajar Islam Dasar (BID).',
      ar: 'أنشئ حساب مشارك جديد للانضمام إلى برنامج تعليم الإسلام الأساسي.',
    },
    nameLabel: { id: 'Nama Lengkap', ar: 'الاسم الكامل' },
    namePlaceholder: { id: 'Contoh: Ahmad', ar: 'مثال: أحمد' },
    emailLabel: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    emailPlaceholder: { id: 'peserta@tslearning.com', ar: 'student@tslearning.com' },
    phoneLabel: { id: 'Nomor Telepon (WhatsApp)', ar: 'رقم الهاتف (الواتساب)' },
    phonePlaceholder: { id: 'Contoh: 08123456789', ar: 'مثال: 08123456789' },
    genderLabel: { id: 'Jenis Kelamin', ar: 'الجنس' },
    genderMale: { id: 'Ikhwan (Laki-laki)', ar: 'إخوان (ذكر)' },
    genderFemale: { id: 'Akhwat (Perempuan)', ar: 'أخوات (أنثى)' },
    passwordLabel: { id: 'Kata Sandi', ar: 'كلمة المرور' },
    passwordPlaceholder: { id: '••••••••', ar: '••••••••' },
    confirmPasswordLabel: { id: 'Konfirmasi Kata Sandi', ar: 'تأكيد كلمة المرور' },
    signupBtn: { id: 'Daftar Akun', ar: 'تسجيل الحساب' },
    alreadyRegistered: { id: 'Sudah memiliki akun?', ar: 'هل لديك حساب بالفعل؟' },
    loginBtn: { id: 'Masuk ke akun', ar: 'تسجيل الدخول' },
    successMsg: {
      id: 'Registrasi berhasil! Silakan masuk dengan akun baru Anda.',
      ar: 'تم التسجيل بنجاح! يرجى تسجيل الدخول بحسابك الجديد.',
    },
    errorMsg: { id: 'Gagal melakukan registrasi.', ar: 'فشل التسجيل.' },
    heroTitleStart: { id: 'Mulai Perjalanan', ar: 'ابدأ مسيرتك' },
    heroTitleEnd: { id: 'Keilmuan Anda', ar: 'العلمية' },
    heroSubtitle: {
      id: 'Bergabunglah dengan komunitas pencari ilmu global yang didedikasikan untuk pengetahuan otentik dan kemurnian keimanan.',
      ar: 'انضم إلى مجتمع عالمي من الباحثين عن العلم المكرسين للمعرفة الأصيلة والصفاء الروحي.',
    },
    features: {
      curriculum: { id: 'Kurikulum Otentik', ar: 'منهج دراسي أصيل' },
      track: { id: 'Jalur Belajar Terstruktur', ar: 'مسارات تعليمية منظمة' },
      community: { id: 'Akses Komunitas Global', ar: 'الوصول إلى مجتمع عالمي' },
      progress: { id: 'Pelacakan Kemajuan Pribadi', ar: 'متابعة التقدم الشخصي' },
    },
    errors: {
      nameMin: { id: 'Nama minimal harus 2 karakter', ar: 'الاسم يجب أن يكون حرفين على الأقل' },
      emailInvalid: { id: 'Format email tidak valid', ar: 'البريد الإلكتروني غير صالح' },
      phoneMin: {
        id: 'Nomor telepon minimal harus 10 karakter',
        ar: 'رقم الهاتف يجب أن يكون 10 أحرف على الأقل',
      },
      passwordMin: {
        id: 'Kata sandi minimal harus 6 karakter',
        ar: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
      },
      confirmPasswordMin: { id: 'Harap konfirmasi kata sandi Anda', ar: 'يرجى تأكيد كلمة المرور' },
      passwordsDontMatch: { id: 'Kata sandi tidak cocok', ar: 'كلمة المرور غير متطابقة' },
    },
  },
  verifyEmail: {
    loadingTitle: { id: 'Memverifikasi Email...', ar: 'جاري التحقق من البريد الإلكتروني...' },
    loadingDesc: {
      id: 'Mohon tunggu sebentar, kami sedang memverifikasi token Anda.',
      ar: 'يرجى الانتظار لحظة، نحن نتحقق من الرمز الخاص بك.',
    },
    successTitle: { id: 'Email Terverifikasi!', ar: 'تم التحقق من البريد الإلكتروني!' },
    successDesc: {
      id: 'Email Anda berhasil diverifikasi. Silakan login untuk mulai belajar.',
      ar: 'تم التحقق من بريدك الإلكتروني بنجاح. يرجى تسجيل الدخول لبدء التعلم.',
    },
    successBtn: { id: 'Lanjutkan ke Login', ar: 'المتابعة إلى تسجيل الدخول' },
    failedTitle: { id: 'Verifikasi Gagal', ar: 'فشل التحقق' },
    backToLogin: { id: 'Kembali ke Login', ar: 'العودة إلى تسجيل الدخول' },
    tokenNotFound: { id: 'Token verifikasi tidak ditemukan.', ar: 'لم يتم العثور على رمز التحقق.' },
    generalError: { id: 'Verifikasi email gagal.', ar: 'فشل التحقق من البريد الإلكتروني.' },
  },
  resetPassword: {
    invalidTokenTitle: { id: 'Token Tidak Valid', ar: 'رمز غير صالح' },
    invalidTokenDesc: {
      id: 'Link reset password tidak lengkap atau tidak valid. Silakan minta link baru di halaman login.',
      ar: 'رابط إعادة تعيين كلمة المرور غير مكتمل أو غير صالح. يرجى طلب رابط جديد من صفحة تسجيل الدخول.',
    },
    backToLogin: { id: 'Kembali ke Login', ar: 'العودة إلى تسجيل الدخول' },
    tokenNotFound: {
      id: 'Token reset password tidak ditemukan.',
      ar: 'لم يتم العثور على رمز إعادة تعيين كلمة المرور.',
    },
    generalError: { id: 'Gagal mereset password.', ar: 'فشل إعادة تعيين كلمة المرور.' },
    successTitle: { id: 'Password Diperbarui', ar: 'تم تحديث كلمة المرور' },
    successDesc: {
      id: 'Password Anda telah berhasil diubah. Silakan login kembali dengan password baru Anda.',
      ar: 'تم تغيير كلمة المرور الخاصة بك بنجاح. يرجى تسجيل الدخول مرة أخرى باستخدام كلمة المرور الجديدة.',
    },
    title: { id: 'Buat Password Baru', ar: 'إنشاء كلمة مرور جديدة' },
    subtitle: {
      id: 'Masukkan password baru Anda untuk akun Tarbiyah Sunnah Learning.',
      ar: 'أدخل كلمة المرور الجديدة لحساب Tarbiyah Sunnah Learning الخاص بك.',
    },
    newPasswordLabel: { id: 'Password Baru', ar: 'كلمة المرور الجديدة' },
    newPasswordPlaceholder: { id: 'Minimal 6 karakter', ar: 'على الأقل 6 أحرف' },
    confirmPasswordLabel: { id: 'Konfirmasi Password Baru', ar: 'تأكيد كلمة المرور الجديدة' },
    confirmPasswordPlaceholder: { id: 'Ulangi password baru', ar: 'كرر كلمة المرور الجديدة' },
    submitBtn: { id: 'Simpan Password', ar: 'حفظ كلمة المرور' },
    validation: {
      passwordMin: {
        id: 'Password minimal 6 karakter',
        ar: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
      },
      confirmPasswordMin: {
        id: 'Konfirmasi password minimal 6 karakter',
        ar: 'تأكيد كلمة المرور يجب أن يكون 6 أحرف على الأقل',
      },
      passwordsDontMatch: { id: 'Password tidak cocok', ar: 'كلمة المرور غير متطابقة' },
    },
  },
  dashboard: {
    gatheringProgress: {
      id: 'Mengumpulkan perkembangan belajar Anda...',
      ar: 'جاري جمع تقدمك الدراسي...',
    },
    welcome: { id: "Assalamu'alaikum", ar: 'السلام عليكم' },
    readyToContinue: { id: 'Siap untuk melanjutkan?', ar: 'هل أنت مستعد للمتابعة؟' },
    learningHub: { id: 'Pusat Aktivitas Belajar', ar: 'مركز أنشطة التعلم' },
    quickAccess: { id: 'Akses cepat', ar: 'الوصول السريع' },
    liveSessionLabel: { id: 'Sesi tatap muka', ar: 'جلسة مباشرة' },
    liveSessionsTitle: { id: 'Tatap Muka Online', ar: 'اللقاءات المباشرة عبر الإنترنت' },
    openMaterial: { id: 'Buka materi', ar: 'فتح المادة' },
    joinLiveSession: { id: 'Gabung tatap muka', ar: 'الانضمام إلى اللقاء' },
    continueLearning: { id: 'Lanjutkan Belajar', ar: 'مواصلة التعلم' },
    nextMilestone: { id: 'Pencapaian Berikutnya', ar: 'المرحلة التالية' },
    browsePrograms: { id: 'Telusuri Program', ar: 'تصفح البرامج' },
    overallProgress: { id: 'Kemajuan Keseluruhan', ar: 'التقدم العام' },
    myPrograms: { id: 'Program Saya', ar: 'برامجي' },
    viewAll: { id: 'Lihat Semua', ar: 'عرض الكل' },
    noEnrollments: {
      id: 'Anda belum terdaftar dalam program apa pun saat ini.',
      ar: 'لم يتم تسجيلك في أي برامج بعد.',
    },
    aiInsights: { id: 'Analisis Belajar', ar: 'تحليلات التعلم' },
    recentActivityTitle: {
      id: '{count} materi selesai dalam 7 hari terakhir',
      ar: 'تم إكمال {count} مادة خلال آخر 7 أيام',
    },
    resumeRhythmTitle: {
      id: 'Saatnya kembali ke ritme belajar Anda',
      ar: 'حان الوقت للعودة إلى وتيرة تعلمك',
    },
    observedStudyTime: {
      id: 'Aktivitas belajar Anda paling sering tercatat pada {timeOfDay} hari, sekitar jam {hour}.',
      ar: 'يتم تسجيل نشاطك التعليمي غالباً في الفترة {timeOfDayAr}، حوالي الساعة {hourAr}.',
    },
    progressShort: { id: 'Progres', ar: 'التقدم' },
    activeProgramsShort: { id: 'Program aktif', ar: 'البرامج النشطة' },
    lastSevenDaysShort: { id: 'Selesai 7 hari', ar: 'مكتمل في 7 أيام' },
    learningSummary: { id: 'Ringkasan aktivitas belajar', ar: 'ملخص نشاط التعلم' },
    viewProgress: { id: 'Lihat progres', ar: 'عرض التقدم' },
    viewPrograms: { id: 'Lihat program', ar: 'عرض البرامج' },
    viewActivity: { id: 'Buka materi', ar: 'فتح المواد' },
    openNextStep: { id: 'Buka langkah berikutnya', ar: 'فتح الخطوة التالية' },
    activeStudyDays: {
      id: 'Hari belajar aktif dalam 7 hari terakhir',
      ar: 'أيام التعلم النشطة خلال آخر 7 أيام',
    },
    programCollection: { id: 'Koleksi pembelajaran', ar: 'مجموعة التعلم' },
    featuredProgram: { id: 'Program utama Anda', ar: 'برنامجك الرئيسي' },
    openProgram: { id: 'Lihat alur program', ar: 'عرض مسار البرنامج' },
    aiInsightsStartTitle: {
      id: 'Ayo mulai langkah pertama belajar Anda hari ini!',
      ar: 'لنبدأ الخطوة الأولى في تعلمك اليوم!',
    },
    aiInsightsDescFallback: {
      id: 'Belajar secara konsisten meskipun sedikit akan memberikan dampak besar. Mulailah mempelajari materi pertama Anda di portal.',
      ar: 'التعلم المستمر وإن كان قليلاً له أثر كبير. ابدأ بدراسة أول درس لك في البوابة.',
    },
    dayAbbreviations: [
      { id: 'M', ar: 'ح' },
      { id: 'S', ar: 'ن' },
      { id: 'S', ar: 'ث' },
      { id: 'R', ar: 'ر' },
      { id: 'K', ar: 'خ' },
      { id: 'J', ar: 'ج' },
      { id: 'S', ar: 'س' },
    ],
    pendingEvaluationsAlertTitle: {
      id: 'Evaluasi & Ujian Siap Dikerjakan',
      ar: 'اختبارات وتقييمات بانتظارك',
    },
    pendingEvaluationsAlertDesc: {
      id: 'Terdapat evaluasi pembelajaran yang belum diselesaikan. Mari tuntaskan evaluasi ini untuk melanjutkan ke tahap berikutnya.',
      ar: 'لديك تقييمات لم تكتمل بعد. يرجى إنجازها للمتابعة إلى المرحلة التالية.',
    },
    inactivityNoticeTitle: {
      id: 'Mari Lanjutkan Semangat Menuntut Ilmu',
      ar: 'واصل رحلتك المباركة في طلب العلم',
    },
    inactivityNoticeDesc: {
      id: 'Sudah beberapa hari belum melanjutkan materi. Sedikit demi sedikit namun istiqamah adalah kunci keberkahan ilmu.',
      ar: 'مرت عدة أيام منذ آخر نشاط. الاستمرار في طلب العلم ولو بالقليل هو مفتاح البركة.',
    },
    actionTakeExam: { id: 'Kerjakan Ujian Tertunda', ar: 'أداء الاختبار المعلق' },
    actionResumeStudy: { id: 'Lanjutkan Materi Belajar', ar: 'متابعة الدرس الأخير' },
    pendingCountBadge: { id: 'Ujian Menunggu', ar: 'اختبار معلق' },
    actionRequired: { id: 'Perlu Tindakan', ar: 'مهام مطلوبة' },
    queue: { id: 'Antrean', ar: 'الطابور' },
    allUpToDate: {
      id: 'Semua alur pembelajaran Anda telah diperbarui dan tuntas.',
      ar: 'جميع مسارات التعلم محدثة ومكتملة.',
    },
    onboardingChecklist: { id: 'Daftar Periksa Onboarding', ar: 'قائمة التهيئة والتهضيم' },
    scholarIdentifier: { id: 'Nomor Induk Peserta', ar: 'رقم تعريف المشارك' },
    noPending: { id: 'Tidak ada aplikasi tertunda.', ar: 'لا توجد طلبات معلقة.' },
    registrationOnboarding: { id: 'Pendaftaran & Onboarding', ar: 'التسجيل والتهيئة' },
    waStep: { id: 'Grup WhatsApp', ar: 'مجموعة الواتساب' },
    profileStep: { id: 'Lengkapi Profil', ar: 'إكمال الملف الشخصي' },
    consentStep: { id: 'Protokol Digital', ar: 'الموافقة الرقمية' },
    orientationStep: { id: 'Materi Orientasi', ar: 'المواد التوجيهية' },
    downloadReceipt: { id: 'Unduh Bukti Pendaftaran', ar: 'تنزيل إيصال التسجيل' },
  },
  programs: {
    syncingPath: {
      id: 'Menyelaraskan dengan alur pembelajaran...',
      ar: 'جاري المزامنة مع مسار التعلم...',
    },
    journeyTitle: { id: 'Perjalanan Belajar', ar: 'مسيرة التعلم' },
    journeySubtitle: {
      id: 'Tingkatkan ilmu Anda, perbaiki akhlak, dan terhubunglah dengan warisan ketakwaan.',
      ar: 'وسع معرفتك، وحسن أخلاقك، وتواصل مع تراث التقوى.',
    },
    myProgramsTab: { id: 'Program Saya', ar: 'برامجي' },
    exploreTab: { id: 'Jelajahi', ar: 'استكشاف' },
    ongoing: { id: 'Sedang Berjalan', ar: 'قيد التنفيذ' },
    progress: { id: 'Kemajuan', ar: 'التقدم' },
    activePrograms: { id: 'Program aktif', ar: 'البرامج النشطة' },
    pendingApplications: { id: 'Pendaftaran diproses', ar: 'التسجيلات قيد المعالجة' },
    noEnrollmentsTitle: { id: 'Belum ada pendaftaran aktif', ar: 'لا توجد تسجيلات نشطة' },
    noEnrollmentsDesc: {
      id: 'Anda belum bergabung dengan program apa pun. Jelajahi program kami untuk menemukan jalur belajar Anda.',
      ar: 'لم تنضم إلى أي برامج بعد. تصفح عروضنا للعثور على المسار المناسب لك.',
    },
    exploreProgramsBtn: { id: 'Jelajahi Program', ar: 'استكشاف البرامج' },
    enrollNow: { id: 'Daftar Sekarang', ar: 'سجل الآن' },
    regClosed: { id: 'Pendaftaran Ditutup', ar: 'التسجيل مغلق' },
    checkLater: {
      id: 'Silakan periksa kembali nanti untuk program-program baru.',
      ar: 'يرجى التحقق لاحقاً من وجود برامج جديدة.',
    },
    // MY-tab label for the timestamp under a pending / non-approved
    // registration card ("Terdaftar pada" / "تاريخ التسجيل").
    submittedOn: { id: 'Terdaftar pada', ar: 'تاريخ التسجيل' },
    // MY-tab label for the SECOND timestamp row that appears under
    // submittedOn when the row has been re-submitted at least once
    // (i.e. registration.lastResubmittedAt is set). Backed by the
    // `lastResubmittedAt` column on ProgramRegistration.
    resubmittedOn: { id: 'Diajukan ulang pada', ar: 'أُعيد تقديمه في' },
    // CTA label rendered on the bottom of a REJECTED / REVISION /
    // CANCELLED registration card in the MY tab. Deep-links to the
    // Registration form for the same program so the user can re-submit
    // in one click instead of navigating through the program detail.
    viewDetailCta: { id: 'Lihat Detail Pendaftaran', ar: 'عرض تفاصيل التسجيل' },
  },
  registration: {
    detailTitle: { id: 'Detail Program', ar: 'تفاصيل البرنامج' },
    profileTitle: { id: 'Verifikasi Profil', ar: 'التحقق من الملف الشخصي' },
    consentTitle: { id: 'Pernyataan Akhir', ar: 'الموافقة النهائية' },
    preparing: { id: 'Menyiapkan alur pendaftaran...', ar: 'جاري إعداد مسار التسجيل...' },
    regClosedTitle: { id: 'Pendaftaran Ditutup', ar: 'التسجيل مغلق' },
    regClosedDesc: {
      id: 'Masa pendaftaran untuk program {name} telah selesai atau belum dimulai. Silakan cek berkala atau jelajahi program lainnya.',
      ar: 'انتهت فترة التسجيل لبرنامج {name} أو لم تبدأ بعد. يرجى التحقق لاحقاً أو استكشاف برامج أخرى.',
    },
    backToPrograms: { id: 'Kembali ke Program', ar: 'العودة إلى البرامج' },
    backToExplore: { id: 'Kembali ke Jelajah', ar: 'العودة إلى الاستكشاف' },
    confirmingTitle: { id: 'Konfirmasi Partisipasi', ar: 'تأكيد المشاركة' },
    confirmingDesc: {
      id: 'Anda memilih untuk bergabung dalam {name}. Kode program {code} ini mewakili alur pembelajaran yang terstruktur.',
      ar: 'لقد اخترت الانضمام إلى {name}. يمثل رمز البرنامج {code} هذا تسلسلاً تعليمياً منظماً.',
    },
    approvalMode: { id: 'Mode Persetujuan', ar: 'وضع الموافقة' },
    registrationWindow: { id: 'Masa Pendaftaran', ar: 'فترة التسجيل' },
    registrationOpensAt: { id: 'Pendaftaran Dibuka', ar: 'يفتح التسجيل' },
    registrationClosesAt: { id: 'Pendaftaran Ditutup', ar: 'يغلق التسجيل' },
    approvalModeVal: {
      AUTO_APPROVE: { id: 'Otomatis', ar: 'تلقائي' },
      MANUAL: { id: 'Manual (Peninjauan)', ar: 'يدوي (مراجعة)' },
    },
    startDate: { id: 'Tanggal Mulai', ar: 'tatarikh البدء' }, // wait, 'تاريخ البدء'
    nextStep: { id: 'Langkah Berikutnya', ar: 'الخطوة التالية' },
    verifyIdentityTitle: { id: 'Verifikasi Identitas Anda', ar: 'التحقق من هويتك' },
    verifyIdentityDesc: {
      id: 'Harap pastikan detail profil Anda sesuai dengan dokumen resmi Anda. Informasi ini akan digunakan untuk sertifikasi.',
      ar: 'يرجى التأكد من تطابق تفاصيل ملفك الشخصي مع مستنداتك الرسمية. سيتم استخدام هذه المعلومات لإصدار الشهادات.',
    },
    fullName: { id: 'Nama Lengkap', ar: 'الاسم الكامل' },
    emailAddress: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    phone: { id: 'Telepon / WhatsApp', ar: 'رقم الهاتف / الواتساب' },
    phoneNotSet: {
      id: 'Tidak tersedia - Perbarui di Profil',
      ar: 'غير متوفر - قم بالتحديث في الملف الشخصي',
    },
    cityLabel: { id: 'Kota Domisili (Sesuai KTP)', ar: 'مدينة الإقامة (وفقاً للبطاقة الشخصية)' },
    cityPlaceholder: {
      id: 'Ketik kabupaten atau kota domisili',
      ar: 'اكتب اسم المنطقة أو المدينة',
    },
    cityDropdownLabel: {
      id: 'Tampilkan saran kabupaten atau kota',
      ar: 'عرض اقتراحات المنطقة أو المدينة',
    },
    cityNoResults: {
      id: 'Tidak ada saran untuk "{query}". Anda tetap dapat menulis domisili sendiri.',
      ar: 'لا توجد اقتراحات لـ "{query}". يمكنك كتابة محل الإقامة يدوياً.',
    },
    reasonLabel: { id: 'Alasan Mengikuti Program', ar: 'سبب الانضمام إلى البرنامج' },
    reasonPlaceholder: {
      id: 'Mengapa Anda tertarik mengikuti program ini?',
      ar: 'لماذا أنت مهتم بالانضمام إلى هذا البرنامج؟',
    },
    cityRequired: {
      id: 'Pilih atau isi kota domisili Anda.',
      ar: 'يرجى اختيار أو إدخال مدينة الإقامة.',
    },
    reasonRequired: {
      id: 'Tuliskan alasan Anda mengikuti program ini.',
      ar: 'يرجى كتابة سبب انضمامك إلى هذا البرنامج.',
    },
    backBtn: { id: 'Kembali', ar: 'السابق' },
    verifyContinueBtn: { id: 'Verifikasi & Lanjutkan', ar: 'التحقق والمتابعة' },
    commitmentTitle: { id: 'Komitmen & Etika', ar: 'الالتزام والأخلاق' },
    commitmentText: {
      id: 'Dengan mendaftar ke program ini, saya mengakui dan menyetujui ketentuan berikut:',
      ar: 'من خلال التسجيل في هذا البرنامج، أقر وأوافق على الشروط التالية:',
    },
    ethics1: {
      id: 'Saya akan menjaga integritas akademik Islam dan perilaku etis sepanjang pembelajaran.',
      ar: 'سوف أحافظ على النزاهة الأكاديمية الإسلامية والسلوك الأخلاقي طوال فترة الدراسة.',
    },
    ethics2: {
      id: 'Saya memahami bahwa perkembangan belajar saya akan dipantau dan ditinjau oleh pengelola.',
      ar: 'أفهم أن تقدمي الدراسي سيكون محل متابعة ومراجعة من sebelum الإدارة.', // wait, 'من قبل الإدارة'
    },
    ethics3: {
      id: 'Saya setuju untuk berpartisipasi dalam evaluasi dan refleksi sesuai yang disyaratkan kurikulum.',
      ar: 'أوافق على المشاركة في التقييمات والتأملات كما يقتضي المنهج الدراسي.',
    },
    ethics4: {
      id: 'Dalam hal persetujuan manual, saya bersedia menunggu proses peninjauan selesai.',
      ar: 'في حالة الموافقة اليدوية، فإنني موافق على الانتظار حتى تكتمل عملية المراجعة.',
    },
    ethicsAccept: {
      id: 'Saya menerima dan menyetujui kebijakan Komitmen & Etika.',
      ar: 'أقبل وأوافق على سياسة الالتزام والأخلاق.',
    },
    additionalNotes: { id: 'Catatan Tambahan (Opsional)', ar: 'ملاحظات إضافية (اختياري)' },
    notesPlaceholder: {
      id: 'Apakah ada hal lain yang perlu kami ketahui?',
      ar: 'هل هناك أي شيء آخر يجب أن نعرفه؟',
    },
    completeEnrollment: { id: 'Selesaikan Pendaftaran', ar: 'إكمال التسجيل' },
    successPendingTitle: {
      id: 'Pendaftaran Berhasil Dikirim!',
      ar: 'تم إرسال التسجيل بنجاح!',
    },
    successPendingDesc: {
      id: 'Jazakumullahu khairan telah mendaftar. Bukti pendaftaran telah dikirim ke email Anda. Tim admin kami sedang memverifikasi data (maksimal 1x24 jam kerja). Tautan grup WhatsApp/Telegram pembelajaran akan dikirimkan otomatis melalui email setelah disetujui.',
      ar: 'جزاكم الله خيراً على التسجيل. تم إرسال إيصال التسجيل إلى بريدك الإلكتروني. يقوم فريق الإشراف بالتحقق من البيانات (خلال ٢٤ ساعة عمل كحد أقصى). سيتم إرسال رابط المجموعة تلقائياً بعد الموافقة.',
    },
    successApprovedTitle: {
      id: 'Selamat, Anda Diterima!',
      ar: 'تهانينا، تم قبولك!',
    },
    successApprovedDesc: {
      id: 'Pendaftaran Anda telah disetujui dan Anda otomatis masuk ke program. Bukti pendaftaran dan tautan grup telah dikirim ke email Anda.',
      ar: 'تمت الموافقة على تسجيلك وانضممت تلقائياً إلى البرنامج. تم إرسال إثبات التسجيل ورابط المجموعة إلى بريدك الإلكتروني.',
    },
    whatsappInvitationTitle: { id: 'Grup Pembelajaran Anda', ar: 'مجموعة التعلم الخاصة بك' },
    whatsappInvitationDesc: {
      id: 'Tautan ini sudah disesuaikan dengan grup belajar yang tersedia.',
      ar: 'تمت مطابقة هذا الرابط مع مجموعة التعلم المتاحة.',
    },
    joinWhatsApp: { id: 'Gabung Grup WhatsApp', ar: 'انضم إلى مجموعة واتساب' },
    groupInvitationPending: {
      id: 'Admin akan mengirim tautan grup saat grup belajar yang sesuai tersedia.',
      ar: 'سيرسل المشرف رابط المجموعة عند توفر مجموعة تعلم مناسبة.',
    },
    successRejectedTitle: {
      id: 'Pendaftaran Belum Diterima',
      ar: 'لم يتم قبول التسجيل',
    },
    successRejectedDesc: {
      id: 'Mohon maaf, pendaftaran Anda belum dapat diterima. Hubungi admin untuk informasi lebih lanjut, atau coba lagi dengan data yang berbeda.',
      ar: 'عذراً، لم يتم قبول تسجيلك. يرجى التواصل مع المسؤول لمزيد من المعلومات، أو حاول مرة أخرى ببيانات مختلفة.',
    },
    successRevisionTitle: {
      id: 'Pendaftaran Perlu Revisi',
      ar: 'يحتاج التسجيل إلى مراجعة',
    },
    successRevisionDesc: {
      id: 'Admin meminta Anda untuk merevisi pendaftaran. Silakan cek pesan dari admin dan kirim ulang pendaftaran Anda.',
      ar: 'طلب منك المسؤول مراجعة التسجيل. يرجى التحقق من رسالة المسؤول وإعادة إرسال التسجيل.',
    },
    tryAgainBtn: { id: 'Coba Lagi', ar: 'حاول مرة أخرى' },
    submitErrorTitle: { id: 'Pendaftaran Gagal', ar: 'فشل التسجيل' },
  },
  publicRegistration: {
    eyebrow: { id: 'Pendaftaran Program', ar: 'تسجيل البرنامج' },
    titlePrefix: { id: 'Formulir Pendaftaran', ar: 'استمارة التسجيل' },
    subtitle: {
      id: 'Lengkapi data berikut untuk membuat akun peserta dan mendaftarkan diri ke program ini.',
      ar: 'أكمل البيانات التالية لإنشاء حساب مشارك والتسجيل في هذا البرنامج.',
    },
    accountSection: { id: 'Data Akun Peserta', ar: 'بيانات حساب المشارك' },
    profileSection: { id: 'Data Pendaftaran', ar: 'بيانات التسجيل' },
    programInfo: { id: 'Informasi Program', ar: 'معلومات البرنامج' },
    directEnrollment: { id: 'Masuk otomatis ke program', ar: 'دخول تلقائي إلى البرنامج' },
    manualReview: { id: 'Menunggu peninjauan admin', ar: 'بانتظار مراجعة الإدارة' },
    registrationOpen: { id: 'Pendaftaran sedang dibuka', ar: 'التسجيل مفتوح حالياً' },
    registrationClosed: { id: 'Pendaftaran tidak tersedia', ar: 'التسجيل غير متاح' },
    scheduleLabel: { id: 'Periode pendaftaran', ar: 'فترة التسجيل' },
    startDateLabel: { id: 'Program dimulai', ar: 'بداية البرنامج' },
    nameLabel: { id: 'Nama lengkap sesuai identitas', ar: 'الاسم الكامل حسب الهوية' },
    emailLabel: { id: 'Alamat email aktif', ar: 'البريد الإلكتروني النشط' },
    phoneLabel: { id: 'Nomor WhatsApp', ar: 'رقم واتساب' },
    genderLabel: { id: 'Jenis kelamin', ar: 'الجنس' },
    male: { id: 'Laki-laki', ar: 'ذكر' },
    female: { id: 'Perempuan', ar: 'أنثى' },
    passwordLabel: { id: 'Buat kata sandi', ar: 'إنشاء كلمة المرور' },
    confirmPasswordLabel: { id: 'Ulangi kata sandi', ar: 'تأكيد كلمة المرور' },
    cityLabel: { id: 'Kota domisili sesuai KTP', ar: 'مدينة الإقامة حسب الهوية' },
    reasonLabel: { id: 'Alasan mengikuti program', ar: 'سبب الالتحاق بالبرنامج' },
    reasonPlaceholder: {
      id: 'Ceritakan secara singkat alasan Anda mengikuti program ini.',
      ar: 'اذكر بإيجاز سبب رغبتك في الالتحاق بهذا البرنامج.',
    },
    consent: {
      id: 'Saya menyetujui ketentuan pendaftaran dan penggunaan data untuk keperluan pembelajaran.',
      ar: 'أوافق على شروط التسجيل واستخدام البيانات لأغراض التعلم.',
    },
    submit: { id: 'Buat Akun & Daftar Program', ar: 'إنشاء حساب والتسجيل في البرنامج' },
    submitting: { id: 'Memproses pendaftaran...', ar: 'جارٍ معالجة التسجيل...' },
    accountExists: {
      id: 'Email ini sudah memiliki akun. Masuk terlebih dahulu untuk menyelesaikan pendaftaran program ini.',
      ar: 'هذا البريد الإلكتروني لديه حساب بالفعل. سجّل الدخول أولاً لإكمال التسجيل في هذا البرنامج.',
    },
    loginToContinue: { id: 'Masuk & Lanjutkan', ar: 'تسجيل الدخول والمتابعة' },
    successAutoTitle: { id: 'Anda sudah terdaftar di program', ar: 'تم تسجيلك في البرنامج' },
    successAutoDesc: {
      id: 'Akun peserta dan enrollment Anda telah dibuat. Verifikasi email Anda, lalu masuk untuk mulai belajar.',
      ar: 'تم إنشاء حساب المشارك وتسجيلك. تحقّق من بريدك الإلكتروني ثم سجّل الدخول لبدء التعلم.',
    },
    successManualTitle: { id: 'Formulir pendaftaran terkirim', ar: 'تم إرسال استمارة التسجيل' },
    successManualDesc: {
      id: 'Akun peserta telah dibuat. Tim admin akan meninjau pendaftaran Anda dan mengirimkan hasilnya melalui email.',
      ar: 'تم إنشاء حساب المشارك. سيقوم فريق الإدارة بمراجعة تسجيلك وإرسال النتيجة عبر البريد الإلكتروني.',
    },
    loginAfterVerification: { id: 'Masuk ke Portal Peserta', ar: 'الدخول إلى بوابة المشارك' },
    unavailableTitle: { id: 'Formulir belum tersedia', ar: 'الاستمارة غير متاحة بعد' },
    unavailableDesc: {
      id: 'Pendaftaran program ini sedang ditutup atau belum memasuki periode pendaftaran.',
      ar: 'تسجيل هذا البرنامج مغلق حالياً أو لم تبدأ فترة التسجيل بعد.',
    },
    invalidLinkTitle: { id: 'Tautan pendaftaran tidak ditemukan', ar: 'رابط التسجيل غير موجود' },
    invalidLinkDesc: {
      id: 'Periksa kembali tautan yang Anda terima atau hubungi penyelenggara program.',
      ar: 'تحقق من الرابط الذي تلقيته أو تواصل مع إدارة البرنامج.',
    },
    fieldInvalid: { id: 'Lengkapi isian ini dengan benar.', ar: 'يرجى إكمال هذا الحقل بشكل صحيح.' },
    passwordMismatch: {
      id: 'Konfirmasi kata sandi belum sama.',
      ar: 'تأكيد كلمة المرور غير مطابق.',
    },
    consentRequired: {
      id: 'Persetujuan pendaftaran wajib diberikan.',
      ar: 'الموافقة على التسجيل مطلوبة.',
    },
    unexpectedError: {
      id: 'Pendaftaran belum dapat diproses. Silakan coba kembali.',
      ar: 'تعذر إتمام التسجيل حالياً. يرجى المحاولة مرة أخرى.',
    },
  },
  curriculum: {
    ariaLabel: { id: 'Posisi dalam kurikulum', ar: 'الموقع في المنهج' },
    currentPosition: { id: 'Posisi belajar saat ini', ar: 'موضع التعلم الحالي' },
    nextPosition: { id: 'Jalur menuju materi berikutnya', ar: 'المسار إلى المادة التالية' },
    program: { id: 'Program', ar: 'البرنامج' },
    level: { id: 'Level', ar: 'المستوى' },
    stage: { id: 'Tahap / Tema', ar: 'المرحلة / الموضوع' },
    subject: { id: 'Mata pelajaran', ar: 'المادة الدراسية' },
    session: { id: 'Pertemuan', ar: 'اللقاء' },
    material: { id: 'Materi', ar: 'المادة التعليمية' },
    evaluation: { id: 'Ujian', ar: 'الاختبار' },
    curriculumMap: { id: 'Peta kurikulum', ar: 'خريطة المنهج' },
    openSession: { id: 'Buka pertemuan', ar: 'فتح اللقاء' },
    lockedReason: { id: 'Selesaikan prasyarat sebelumnya', ar: 'أكمل المتطلبات السابقة' },
  },
  programDetail: {
    loading: { id: 'Memuat detail program...', ar: 'جاري تحميل تفاصيل البرنامج...' },
    accessError: { id: 'Kesalahan Akses Program', ar: 'خطأ في الوصول إلى البرنامج' },
    notEnrolled: {
      id: 'Anda mungkin belum terdaftar di program ini atau program tidak ditemukan.',
      ar: 'قد لا تكون مسجلاً في هذا البرنامج أو أنه غير موجود.',
    },
    backToMyPrograms: { id: 'Kembali ke Program Saya', ar: 'العودة إلى برامجي' },
    progressTitle: { id: 'Kemajuan Belajar Saya', ar: 'تقدمي الدراسي' },
    continueLearning: { id: 'Lanjutkan belajar', ar: 'مواصلة التعلم' },
    nextMaterial: { id: 'Materi berikutnya', ar: 'المادة التالية' },
    allStages: { id: 'Semua tahap', ar: 'جميع المراحل' },
    stageLabel: { id: 'Tahap', ar: 'المرحلة' },
    clearSearch: { id: 'Hapus pencarian', ar: 'مسح البحث' },
    searchPlaceholder: {
      id: 'Cari materi atau nomor pertemuan',
      ar: 'ابحث عن المادة أو رقم اللقاء',
    },
    noMaterials: {
      id: 'Belum ada materi pembelajaran yang tersedia.',
      ar: 'لا توجد مواد تعليمية متاحة بعد.',
    },
    locked: { id: 'Terkunci', ar: 'مغلق' },
    study: { id: 'Pelajari', ar: 'دراسة' },
    quiz: { id: 'Kuis', ar: 'اختبار' },
    passed: { id: 'Lulus', ar: 'ناجح' },
    finalMilestones: { id: 'Pencapaian Akhir', ar: 'المراحل النهائية' },
    assessmentsCompletion: { id: 'Evaluasi & Ketuntasan', ar: 'التقييمات والإكمال' },
    passingScore: { id: 'KKM', ar: 'درجة النجاح' },
    unlockHint: {
      id: 'Selesaikan semua materi untuk membuka',
      ar: 'أكمل جميع المواد لفتح هذا القسم',
    },
    sessionContents: { id: 'Materi & ujian pertemuan', ar: 'مواد واختبارات اللقاء' },
    noSessionContent: { id: 'Belum ada materi atau ujian', ar: 'لا توجد مواد أو اختبارات بعد' },
    openAgain: { id: 'Buka kembali', ar: 'فتح مرة أخرى' },
    startMaterial: { id: 'Mulai materi', ar: 'بدء المادة' },
    examLockedHint: { id: 'Tuntaskan materi pertemuan', ar: 'أكمل مواد اللقاء' },
    startExam: { id: 'Mulai Ujian', ar: 'بدء الامتحان' },
  },
  materials: {
    title: { id: 'Materi Belajar', ar: 'المواد التعليمية' },
    subtitle: {
      id: 'Kumpulan seluruh materi pembelajaran aktif Anda',
      ar: 'مجموعة من جميع المواد التعليمية النشطة الخاصة بك',
    },
    lastStudied: { id: 'Terakhir Dipelajari', ar: 'آخر ما تم دراسته' },
    continueStudy: { id: 'Lanjutkan Mempelajari', ar: 'مواصلة الدراسة' },
    nextUp: { id: 'Berikutnya untuk dipelajari', ar: 'التالي للدراسة' },
    openMaterial: { id: 'Buka materi', ar: 'فتح المادة' },
    searchPlaceholder: {
      id: 'Cari judul atau deskripsi materi',
      ar: 'البحث في عنوان أو وصف المادة',
    },
    clearSearch: { id: 'Hapus pencarian', ar: 'مسح البحث' },
    viewDetails: { id: 'Lihat Detail', ar: 'عرض التفاصيل' },
    studyBtn: { id: 'Pelajari', ar: 'دراسة' },
    noMaterials: {
      id: 'Belum ada materi belajar yang aktif.',
      ar: 'لا توجد مواد تعليمية نشطة بعد.',
    },
    loadingLibrary: { id: 'Memuat perpustakaan materi...', ar: 'جاري تحميل مكتبة المواد...' },
    materialsCount: {
      id: '{count} materi tersedia di jalur belajar Anda saat ini',
      ar: 'يوجد {count} من المواد المتاحة في مسارك الحالي',
    },
    noMaterialsFound: {
      id: 'Tidak ada materi yang ditemukan dalam kategori ini.',
      ar: 'لم يتم العثور pada مواد في هذه الفئة.',
    }, // wait, 'لم يتم العثور على مواد في هذه الفئة.'
    filters: {
      all: { id: 'Semua', ar: 'الكل' },
      video: { id: 'Video', ar: 'فيديو' },
      document: { id: 'Dokumen', ar: 'مستندات' },
      quiz: { id: 'Kuis', ar: 'اختبارات' },
      completed: { id: 'Selesai', ar: 'مكتمل' },
    },
  },
  materialDetail: {
    loading: { id: 'Memuat materi...', ar: 'جاري تحميل المادة...' },
    accessError: { id: 'Gagal Memuat Materi', ar: 'فشل في تحميل المادة' },
    completeMark: { id: 'Tandai Selesai', ar: 'تعيين كمكتمل' },
    completed: { id: 'Selesai', ar: 'مكتمل' },
    nextMaterial: { id: 'Materi Selanjutnya', ar: 'المادة التالية' },
    prevMaterial: { id: 'Materi Sebelumnya', ar: 'المادة السابقة' },
    reflectionTab: { id: 'Refleksi', ar: 'تأمل وتلخيص' },
    notesTab: { id: 'Catatan', ar: 'ملاحظات' },
    videoTab: { id: 'Video', ar: 'فيديو' },
    audioTab: { id: 'Audio', ar: 'صوت' },
    backToProgram: { id: 'Kembali ke Alur Program', ar: 'العودة إلى مسار البرنامج' },
    reflectionTitle: { id: 'Tulis Refleksi Belajar Anda', ar: 'اكتب تأملك للمادة' },
    reflectionDesc: {
      id: 'Tuliskan poin penting, pemahaman utama, dan hikmah yang Anda dapatkan dari materi ini sebagai syarat ketuntasan.',
      ar: 'اكتب النقاط الرئيسية، والفهم الأساسي، والحكمة التي اكتسبتها من هذه المادة كشرط للإكمال.',
    },
    reflectionPrompt: {
      id: 'Apa poin penting yang Anda pelajari dari materi ini?',
      ar: 'ما هي النقاط الرئيسية التي استفدتها من هذه المادة؟',
    },
    submitReflection: { id: 'Kirim Refleksi', ar: 'إرسال التأمل' },
    reflectionSaved: { id: 'Refleksi berhasil disimpan.', ar: 'تم حفظ التأمل بنجاح.' },
    submitFeedback: { id: 'Kirim Umpan Balik', ar: 'إرسال الملاحظات' },
    statusAwaiting: { id: 'Menunggu Review Pengajar', ar: 'في انتظار مراجعة المعلم' },
    statusApproved: { id: 'Disetujui', ar: 'مقبول' },
    statusRevision: { id: 'Perlu Revisi', ar: 'بحاجة للمراجعة' },
    lockedTitle: { id: 'Materi Terkunci', ar: 'المادة مغلقة' },
    lockedDesc: {
      id: 'Konten ini terkunci dalam alur pembelajaran sekuensial. Harap selesaikan semua materi sebelumnya sebelum mengakses materi ini.',
      ar: 'هذا المحتوى مغلق ضمن مسار تعليمي متسلسل. يرجى إكمال جميع المواد السابقة قبل الوصول إلى هذا الدرس.',
    },
    backToCurriculum: { id: 'Kembali ke Kurikulum', ar: 'العودة إلى المنهج الدراسي' },
    notFound: { id: 'Materi tidak ditemukan', ar: 'لم يتم العثور على المادة' },
    learned: { id: 'Sudah Dipelajari', ar: 'تم دراستها' },
    milestoneReady: { id: 'Siap Selesai', ar: 'جاهز للإكمال' },
    finishVideo: { id: 'Selesaikan video untuk melanjutkan', ar: 'أكمل الفيديو للمتابعة' },
    listenAudio: { id: 'Dengarkan audio untuk melanjutkan', ar: 'استمع إلى الصوت للمتابعة' },
    completeContent: { id: 'Selesaikan konten untuk melanjutkan', ar: 'أكمل المحتوى للمتابعة' },
    iHaveLearned: { id: 'Saya sudah mempelajari ini', ar: 'لقد درست هذا' },
    materialContext: { id: 'Konteks Materi', ar: 'سياق المادة' },
    defaultContent: {
      id: 'Materi ini mencakup konsep-konsep inti yang penting untuk perkembangan keimanan dan akademik Anda. Kami menyarankan Anda untuk mencatat saat menonton atau mendengarkan konten.',
      ar: 'تغطي هذه المادة المفاهيم الأساسية الضرورية لتطورك الروحي والأكاديمي. ننصحك بتدوين الملاحظات أثناء المشاهدة أو الاستماع.',
    },
    reflectionLoop: { id: 'Refleksi Belajar', ar: 'حلقة التأمل' },
    reflectionSolidify: {
      id: 'Refleksi membantu memperkuat ingatan dan pemahaman Anda. Anda dapat menuliskan pemikiran Anda di bawah ini.',
      ar: 'يساعد التأمل في ترسيخ معرفتك. يمكنك مشاركة أفكارك أدناه اختياريا.',
    },
    keyTakeaways: {
      id: 'Poin Penting & Rencana Penerapan',
      ar: 'الفوائد الرئيسية والخطط التطبيقية',
    },
    takeawaysPlaceholder: {
      id: 'Apa yang menyentuh hati Anda dalam pelajaran ini? Bagaimana Anda akan menerapkannya hari ini?',
      ar: 'ما الذي أثر فيك في هذا الدرس؟ وكيف ستطبقه اليوم؟',
    },
    characters: { id: 'karakter', ar: 'حرفًا' },
    mentorsOnly: { id: 'Hanya dapat dilihat oleh mentor', ar: 'مرئي للموجهين فقط' },
    curriculumContext: { id: 'Konteks Kurikulum', ar: 'سياق المنهج' },
    estimated: { id: 'Estimasi', ar: 'الوقت المقدر' },
    minRead: { id: 'menit baca', ar: 'دقيقة قراءة' },
    component: { id: 'Komponen', ar: 'المكون' },
    essential: { id: 'Penting', ar: 'أساسي' },
    assessments: { id: 'Penilaian', ar: 'التقييمات' },
    attachments: { id: 'Lampiran & Aset', ar: 'المرفقات والأصول' },
    untitledAsset: { id: 'Aset Tanpa Judul', ar: 'أصل بدون عنوان' },
    noteFromAdmin: { id: 'Catatan dari Admin', ar: 'ملاحظة من المسؤول' },
    adminNoteText: {
      id: '"Tetap konsisten dalam belajar setiap hari. Amal yang sedikit namun berkelanjutan adalah yang paling dicintai oleh Sang Pencipta."',
      ar: '"حافظ على الاستمرارية في تعلمك اليومي. إن أحب الأعمال إلى الله أدومها وإن قل."',
    },
  },
  evaluations: {
    title: { id: 'Evaluasi & Ujian', ar: 'التقييمات والامتحانات' },
    subtitle: {
      id: 'Kelola kuis materi dan ujian komprehensif Anda',
      ar: 'إدارة اختبارات المواد والامتحانات الشاملة الخاصة بك',
    },
    quiz: { id: 'Kuis Materi', ar: 'اختبار مادة' },
    exam: { id: 'Ujian Akhir', ar: 'الامتحان النهائي' },
    survey: { id: 'Survei Umpan Balik', ar: 'استطلاع رأي' },
    passingScore: { id: 'Nilai Kelulusan', ar: 'درجة النجاح' },
    timeLimit: { id: 'Batas Waktu', ar: 'الحد الزمني' },
    attempts: { id: 'Sisa Percobaan', ar: 'المحاولات المتبقية' },
    noEvaluations: { id: 'Belum ada evaluasi yang tersedia.', ar: 'لا توجد تقييمات متاحة بعد.' },
    startBtn: { id: 'Mulai Pengerjaan', ar: 'بدء المحاولة' },
    resultsBtn: { id: 'Lihat Hasil', ar: 'عرض النتائج' },
    infinite: { id: 'Tanpa Batas', ar: 'غير terbatas' }, // wait, 'غير محدود'
    minutes: { id: 'Menit', ar: 'دقائق' },
    loading: { id: 'Memuat penilaian...', ar: 'جاري تحميل التقييمات...' },
    errorTitle: { id: 'Gagal Memuat Penilaian', ar: 'خطأ في تحميل التقييمات' },
    noEvaluationsTitle: { id: 'Belum Ada Evaluasi', ar: 'لا توجد تقييمات بعد' },
    noEvaluationsDesc: {
      id: 'Anda belum memiliki evaluasi yang ditugaskan. Silakan cek kembali nanti atau selesaikan materi pembelajaran terlebih dahulu untuk membuka penilaian baru.',
      ar: 'لم يتم تعيين أي تقييمات لك بعد. يرجى التحقق لاحقًا أو إكمال المزيد من المواد لفتح تقييمات جديدة.',
    },
    totalAssigned: {
      id: 'total penilaian ditugaskan kepada Anda',
      ar: 'إجمالي التقييمات المعينة لك',
    },
    generalAssessments: { id: 'Penilaian Umum', ar: 'التقييمات العامة' },
    noDescription: { id: 'Tidak ada deskripsi', ar: 'لا يوجد وصف' },
    noLimit: { id: 'Tanpa Batas', ar: 'بدون حد' },
    passMark: { id: 'Nilai Kelulusan', ar: 'درجة النجاح' },
    statusPassed: { id: 'Lulus', ar: 'ناجح' },
    statusRemedial: { id: 'Perlu Remedial', ar: 'يحتاج إعادة' },
    statusNotAttempted: { id: 'Belum Dikerjakan', ar: 'لم يتم إنجازه' },
    filterAll: { id: 'Semua Evaluasi', ar: 'جميع التقييمات' },
    filterPending: { id: 'Belum Selesai / Tertunda', ar: 'معلق / غير مكتمل' },
    filterCompleted: { id: 'Sudah Selesai / Lulus', ar: 'مكتمل / ناجح' },
    allPrograms: { id: 'Semua Program', ar: 'جميع البرامج' },
    searchPlaceholder: { id: 'Cari judul evaluasi...', ar: 'البحث عن تقييم...' },
    takeExamBtn: { id: 'Kerjakan Sekarang', ar: 'بدء الآن' },
    retakeExamBtn: { id: 'Ulangi Ujian', ar: 'إعادة المحاولة' },
    viewResultBtn: { id: 'Lembar Hasil', ar: 'عرض النتيجة' },
    score: { id: 'Nilai', ar: 'الدرجة' },
    lockedExam: { id: 'Terkunci (Selesaikan materi sebelumnya)', ar: 'مغلق (أكمل الدروس السابقة)' },
  },
  evaluationDetail: {
    title: { id: 'Lembar Evaluasi', ar: 'ورقة التقييم' },
    backToCurriculum: { id: 'Kembali ke kurikulum program', ar: 'العودة إلى منهج البرنامج' },
    continueCurriculum: { id: 'Lanjut ke tahap berikutnya', ar: 'متابعة المرحلة التالية' },
    duration: { id: 'Batas Waktu', ar: 'الحد الزمني' },
    remainingTime: { id: 'Sisa Waktu', ar: 'الوقت المتبقي' },
    question: { id: 'Pertanyaan', ar: 'سؤال' },
    nextBtn: { id: 'Selanjutnya', ar: 'التالي' },
    prevBtn: { id: 'Sebelumnya', ar: 'السابق' },
    submitBtn: { id: 'Kirim Jawaban', ar: 'إرسال الإجابات' },
    confirmSubmit: {
      id: 'Apakah Anda yakin ingin mengirim jawaban ini?',
      ar: 'هل أنت متأكد من إرسال هذه الإجابة؟',
    },
    calibration: { id: 'Menghitung skor Anda...', ar: 'جاري حساب درجتك...' },
    submitting: { id: 'Mengirimkan jawaban...', ar: 'جاري إرسال الإجابة...' },
    loading: { id: 'Menyelaraskan data penilaian...', ar: 'جاري مزامنة بيانات التقييم...' },
    errorTitle: { id: 'Penilaian Offline', ar: 'التقييم غير متصل' },
    errorDesc: {
      id: 'Kami tidak dapat menyelaraskan data penilaian. Silakan coba lagi nanti.',
      ar: 'لم نتمكن من مزامنة بيانات التقييم. يرجى المحاولة مرة أخرى لاحقًا.',
    },
    backBtn: { id: 'Kembali ke Evaluasi', ar: 'العودة إلى التقييمات' },
    passedTitle: { id: 'Mabruk! Anda Lulus.', ar: 'مبروك! لقد نجحت.' },
    failedTitle: { id: 'Belum Lulus.', ar: 'لم تنجح بعد.' },
    passedDesc: {
      id: 'Dedikasi belajar Anda membuahkan hasil. Anda telah menguasai materi ini.',
      ar: 'لقد أثمر تفانيك في التعلم. لقد أتقنت هذه المادة.',
    },
    failedDesc: {
      id: 'Mengulang adalah bagian dari perjalanan belajar. Pelajari kembali materi dan coba lagi saat Anda siap.',
      ar: 'المراجعة جزء من رحلة التعلم. راجع المواد وحاول مرة أخرى عندما تكون مستعدًا.',
    },
    performance: { id: 'Performa Anda', ar: 'أداؤك' },
    passingScore: { id: 'Nilai Kelulusan', ar: 'درجة النجاح' },
    submitted: { id: 'Terkirim', ar: 'تم الإرسال' },
    timeUsed: { id: 'Waktu Digunakan', ar: 'الوقت المستغرق' },
    minutes: { id: 'menit', ar: 'دقائق' },
    proceedReflection: { id: 'Lanjut ke Refleksi', ar: 'الانتقال إلى التأمل' },
    continueLearning: { id: 'Lanjutkan Belajar', ar: 'مواصلة التعلم' },
    retakeBtn: { id: 'Kerjakan Ulang Evaluasi', ar: 'إعادة المحاولة' },
    finishBtn: { id: 'Selesai', ar: 'إنهاء' },
    recheckConfirmTitle: { id: 'Periksa Kembali Jawaban?', ar: 'هل تريد مراجعة الإجابات؟' },
    recheckConfirmDesc: {
      id: 'Apakah Anda ingin mengirimkan jawaban Anda sekarang, atau ingin memeriksanya kembali terlebih dahulu?',
      ar: 'هل تريد إرسال إجاباتك الآن، أم تريد مراجعتها أولاً؟',
    },
    recheckConfirmSubmit: { id: 'Kirim Jawaban', ar: 'إرسال الإجابات' },
    recheckConfirmCancel: { id: 'Periksa Kembali', ar: 'مراجعة' },
    unansweredWarning: {
      id: 'Ada {count} soal yang belum dijawab. Selesaikan semua soal terlebih dahulu.',
      ar: 'هناك {count} أسئلة لم تتم الإجابة عليها. يرجى إكمال جميع الأسئلة أولاً.',
    },
    allAnsweredFeedback: {
      id: 'Semua soal telah dijawab. Anda dapat mengirimkan jawaban sekarang.',
      ar: 'لقد تمت الإجابة على جميع الأسئلة. يمكنك إرسال الإجابات الآن.',
    },
    rules: { id: 'Aturan Penilaian', ar: 'قواعد التقييم' },
    timeLimit: { id: 'Batas Waktu', ar: 'الحد الزمني' },
    passingCriteria: { id: 'Kriteria Kelulusan', ar: 'معايير النجاح' },
    passingCriteriaDesc: {
      id: 'Dibutuhkan skor minimal {score}%',
      ar: 'مطلوب درجة لا تقل عن {score}%',
    },
    attemptLimit: { id: 'Batas Percobaan', ar: 'حد المحاولات' },
    attemptLimitDesc: {
      id: 'Maksimal {max} kali percobaan',
      ar: 'الحد الأقصى {max} محاولات مسموح بها',
    },
    questionPool: { id: 'Bank Soal', ar: 'بنك الأسئلة' },
    questionPoolDesc: {
      id: 'Sistem akan mengambil {sample} dari {total} soal di bank secara acak untuk setiap percobaan.',
      ar: 'سيقوم النظام بسحب {sample} من أصل {total} سؤال في البنك بشكل عشوائي لكل محاولة.',
    },
    attemptLimitReached: {
      id: 'Batas maksimal percobaan telah tercapai.',
      ar: 'تم الوصول إلى الحد الأقصى للمحاولات.',
    },
    attemptLimitReachedDesc: {
      id: 'Anda tidak dapat mengerjakan ulang evaluasi ini karena batas percobaan ({max}) telah habis. Silakan hubungi admin jika Anda membutuhkan bantuan.',
      ar: 'لا يمكنك إعادة محاولة هذا التقييم لأن حد المحاولات ({max}) قد نفد. يرجى الاتصال بالمسؤول إذا كنت بحاجة إلى مساعدة.',
    },
    ackStart: {
      id: 'Dengan mengeklik mulai, Anda menyatakan siap untuk memulai.',
      ar: 'بالنقر على بدء، فإنك تقر بأنك مستعد للبدء.',
    },
    ackExam: {
      id: 'Ini adalah ujian akhir dengan pengaruh signifikan terhadap sertifikasi Anda.',
      ar: 'هذا امتحان نهائي وله وزن كبير في شهادتك.',
    },
    startBtn: { id: 'Mulai Penilaian', ar: 'بدء التقييم' },
    defaultDesc: {
      id: 'Selamat datang di penilaian ini. Harap pastikan Anda berada di lingkungan yang tenang dan telah mempelajari materi prasyarat.',
      ar: 'مرحباً بك في هذا التقييم. يرجى التأكد من أنك في بيئة هادئة ومراجعة المواد المطلوبة.',
    },
    correctAnswer: { id: 'Jawaban Benar', ar: 'الإجابة الصحيحة' },
    yourAnswer: { id: 'Jawaban Anda', ar: 'إجابتك' },
    isCorrect: { id: 'Benar', ar: 'صحيح' },
    isIncorrect: { id: 'Salah', ar: 'خطأ' },
    explanation: { id: 'Penjelasan', ar: 'شرح' },
  },
  results: {
    calculating: { id: 'Menghitung hasil belajar Anda...', ar: 'جاري حساب نتائجك الدراسية...' },
    errorTitle: { id: 'Gagal Memuat Hasil', ar: 'خطأ في تحميل النتائج' },
    noResultsTitle: { id: 'Belum Ada Hasil', ar: 'لا توجد نتائج بعد' },
    noResultsDesc: {
      id: 'Selesaikan program belajar untuk melihat laporan hasil belajar Anda di sini.',
      ar: 'أكمل البرامج الدراسية لعرض تقارير نتائجك هنا.',
    },
    title: { id: 'Hasil Belajar', ar: 'نتائج التعلم' },
    subtitle: {
      id: 'Status ketuntasan Anda di seluruh program belajar',
      ar: 'حالة إكمالك عبر جميع البرامج الدراسية',
    },
    score: { id: 'Nilai', ar: 'الدرجة' },
    passed: { id: 'Tuntas', ar: 'ناجح' },
    failed: { id: 'Belum Tuntas', ar: 'غير ناجح' },
    certTitle: { id: 'Sertifikat Kelulusan', ar: 'شهادة التخرج' },
    downloadCert: { id: 'Unduh Sertifikat', ar: 'تنزيل الشهادة' },
    feedbackTitle: { id: 'Umpan Balik Pengajar', ar: 'ملاحظات المعلم العلمي' },
    strengths: { id: 'Kelebihan Anda', ar: 'نقاط القوة' },
    weaknesses: { id: 'Perlu Penguatan', ar: 'بحاجة إلى تعزيز' },
    recommendations: { id: 'Rekomendasi Jalur', ar: 'المسار الموصى به' },
    noResults: { id: 'Tidak ada hasil penilaian untuk ditampilkan.', ar: 'لا توجد نتائج لعرضها.' },
    comprehensive: { id: 'Ujian Komprehensif (Wajib)', ar: 'الامتحان الشامل (مطلوب)' },
    reflectionLabel: { id: 'Refleksi Pembelajaran (Wajib)', ar: 'التأمل التعليمي (مطلوب)' },
    overallSummary: { id: 'Ringkasan Keseluruhan', ar: 'الملخص العام' },
    totalPrograms: { id: 'Total Program', ar: 'إجمالي البرامج' },
    completed: { id: 'Selesai', ar: 'مكتمل' },
    inProgress: { id: 'Sedang Berjalan', ar: 'قيد التنفيذ' },
    avgProgress: { id: 'Rata-rata Kemajuan', ar: 'متوسط التقدم' },
  },
  profile: {
    title: { id: 'Profil Peserta', ar: 'ملف المشارك' },
    accountOverview: { id: 'Ruang Akun Peserta', ar: 'مساحة حساب المشارك' },
    backToDashboard: { id: 'Kembali ke dashboard', ar: 'العودة إلى لوحة التحكم' },
    accountReady: { id: 'Akun peserta aktif', ar: 'حساب المشارك نشط' },
    profileCompletion: { id: 'Kelengkapan profil', ar: 'اكتمال الملف الشخصي' },
    profileCompletionDesc: {
      id: 'Lengkapi data agar layanan akademik dan komunikasi tetap lancar.',
      ar: 'أكمل بياناتك لضمان سلاسة الخدمات الأكاديمية والتواصل.',
    },
    profileNavigation: { id: 'Navigasi profil', ar: 'التنقل في الملف الشخصي' },
    profileIdentity: { id: 'Identitas', ar: 'الهوية' },
    profileLearning: { id: 'Pembelajaran', ar: 'التعلم' },
    profileAccount: { id: 'Akun & Keamanan', ar: 'الحساب والأمان' },
    subtitle: {
      id: 'Kelola informasi pribadi dan data akademik Anda',
      ar: 'إدارة معلوماتك الشخصية وبياناتك الأكاديمية',
    },
    personalInfo: { id: 'Informasi Pribadi', ar: 'المعلومات الشخصية' },
    academicInfo: { id: 'Status Akademik', ar: 'الحالة الأكاديمية' },
    updateBtn: { id: 'Perbarui Profil', ar: 'تحديث الملف الشخصي' },
    successMsg: { id: 'Profil berhasil diperbarui.', ar: 'تم تحديث الملف الشخصي بنجاح.' },
    errorMsg: { id: 'Gagal memperbarui profil.', ar: 'فشل تحديث الملف الشخصي.' },
    name: { id: 'Nama Lengkap', ar: 'الاسم الكامل' },
    email: { id: 'Alamat Email', ar: 'البريد الإلكتروني' },
    phone: { id: 'Nomor Telepon (WhatsApp)', ar: 'رقم الهاتف (الواتساب)' },
    gender: { id: 'Jenis Kelamin', ar: 'الجنس' },
    editProfile: { id: 'Edit Profil', ar: 'تعديل الملف الشخصي' },
    tagline: {
      id: 'Mempelajari ilmu-ilmu Islam dan pengetahuan tradisional',
      ar: 'تعلم العلوم الإسلامية والمعارف التقليدية',
    },
    memberSince: { id: 'Anggota sejak', ar: 'عضو منذ' },
    recently: { id: 'Baru-baru ini', ar: 'مؤخراً' },
    contactInfo: { id: 'Informasi Kontak', ar: 'معلومات الاتصال' },
    manageDetails: { id: 'Kelola data', ar: 'إدارة البيانات' },
    change: { id: 'Ubah', ar: 'تغيير' },
    myRegistrations: { id: 'Pendaftaran & Bukti Saya', ar: 'تسجيلاتي وإيصالاتي' },
    registrationRecords: { id: 'Riwayat pendaftaran', ar: 'سجل التسجيلات' },
    viewPrograms: { id: 'Lihat program', ar: 'عرض البرامج' },
    openProgram: { id: 'Buka program', ar: 'فتح البرنامج' },
    browsePrograms: { id: 'Jelajahi program', ar: 'استكشف البرامج' },
    receipt: { id: 'Bukti', ar: 'إيصال' },
    noRegistrations: {
      id: 'Tidak ada pendaftaran ditemukan.',
      ar: 'لم يتم العثور على أي تسجيلات.',
    },
    learningStats: { id: 'Statistik Belajar', ar: 'إحصائيات التعلم' },
    learningOverview: { id: 'Ringkasan perjalanan belajar', ar: 'ملخص مسيرة التعلم' },
    activePrograms: { id: 'Program Aktif', ar: 'البرامج النشطة' },
    materialsCompleted: { id: 'Materi Selesai', ar: 'المواد المكتملة' },
    programsCompleted: { id: 'Program Selesai', ar: 'البرامج المكتملة' },
    avgCompletion: { id: 'Rata-rata Ketuntasan', ar: 'متوسط الإكمال' },
    accountSettings: { id: 'Pengaturan Akun', ar: 'إعدادات الحساب' },
    accountAndSecurity: { id: 'Akun dan keamanan', ar: 'الحساب والأمان' },
    dataProfile: { id: 'Data profil', ar: 'بيانات الملف الشخصي' },
    dataProfileDesc: {
      id: 'Perbarui identitas, kontak, dan foto profil.',
      ar: 'حدّث الهوية وبيانات الاتصال والصورة الشخصية.',
    },
    securityDesc: {
      id: 'Perbarui kata sandi untuk menjaga akses akun.',
      ar: 'حدّث كلمة المرور للحفاظ على أمان الوصول للحساب.',
    },
    changePassword: { id: 'Ubah Kata Sandi', ar: 'تغيير كلمة المرور' },
    notificationPrefs: { id: 'Preferensi Notifikasi', ar: 'تفضيلات الإشعارات' },
    privacySettings: { id: 'Pengaturan Privasi', ar: 'إعدادات الخصوصية' },
    signOut: { id: 'Keluar', ar: 'تسجيل الخروج' },
    signOutDesc: {
      id: 'Akhiri sesi pada perangkat ini.',
      ar: 'إنهاء الجلسة على هذا الجهاز.',
    },
    dangerZone: { id: 'Zona Bahaya', ar: 'منطقة الخطر' },
    cannotBeUndone: {
      id: 'Tindakan ini tidak dapat dibatalkan.',
      ar: 'لا يمكن التراجع عن هذا الإجراء.',
    },
    deleteAccount: { id: 'Hapus Akun', ar: 'حذف الحساب' },
    confirmSignOut: { id: 'Apakah Anda yakin ingin keluar?', ar: 'هل أنت متأكد من تسجيل الخروج؟' },
    currentPasswordLabel: { id: 'Password Saat Ini', ar: 'كلمة المرور الحالية' },
    newPasswordLabel: { id: 'Password Baru', ar: 'كلمة المرور الجديدة' },
    confirmNewPasswordLabel: { id: 'Konfirmasi Password Baru', ar: 'تأكيد كلمة المرور الجديدة' },
    showPassword: { id: 'Tampilkan kata sandi', ar: 'إظهار كلمة المرور' },
    hidePassword: { id: 'Sembunyikan kata sandi', ar: 'إخفاء كلمة المرور' },
    saving: { id: 'Menyimpan...', ar: 'جاري الحفظ...' },
    errorChangePassword: { id: 'Gagal mengubah password', ar: 'فشل تغيير كلمة المرور' },
    passwordMismatch: {
      id: 'Konfirmasi password baru tidak cocok',
      ar: 'تأكيد كلمة المرور الجديدة غير متطابق',
    },
    passwordMinLength: {
      id: 'Password baru minimal 6 karakter',
      ar: 'كلمة المرور الجديدة harus 6 أحرف على الأقل',
    },
    avatar: { id: 'Avatar', ar: 'الصورة الشخصية' },
    uploadImage: { id: 'Unggah Foto', ar: 'تحميل الصورة' },
    nameShort: { id: 'Nama', ar: 'الاسم' },
    genderMale: { id: 'Laki-laki (Ikhwan)', ar: 'ذكر (إخوان)' },
    genderFemale: { id: 'Perempuan (Akhwat)', ar: 'أنثى (أخوات)' },
    dateOfBirth: { id: 'Tanggal Lahir', ar: 'تاريخ الميلاد' },
  },
  receipt: {
    title: { id: 'Bukti Pendaftaran', ar: 'إثبات التسجيل' },
    subtitle: {
      id: 'Tanda bukti pendaftaran program belajar resmi Anda',
      ar: 'إيصال رسمي لتسجيلك في البرنامج الدراسي',
    },
    invoiceNo: { id: 'Nomor Bukti', ar: 'رقم الإيصال' },
    paymentDate: { id: 'Tanggal Terbit', ar: 'تاريخ الإصدار' },
    amount: { id: 'Nominal', ar: 'المبلغ' },
    status: { id: 'Status Validasi', ar: 'حالة التحقق' },
    downloadPdf: { id: 'Unduh Bukti (PDF)', ar: 'تنزيل الإيصال (PDF)' },
    closeBtn: { id: 'Tutup Halaman', ar: 'إغلاق الصفحة' },
    backToDashboard: { id: 'Kembali ke Dashboard', ar: 'العودة إلى لوحة القيادة' },
    printArchive: { id: 'Cetak Bukti', ar: 'طباعة الإيصال' },
    dossierProof: { id: 'Bukti Dokumen', ar: 'إثبات المستند' },
    digitalReceiptSub: {
      id: 'Bukti Pendaftaran Digital • LMS BID V3',
      ar: 'إيصال التسجيل الرقمي • LMS BID V3',
    },
    identifier: { id: 'Identifikasi', ar: 'المعرف' },
    scholarIdentity: { id: 'Identitas Peserta', ar: 'هوية المشارك' },
    scholarIdentifier: { id: 'Nomor Induk Peserta', ar: 'رقم تعريف المشارك' },
    communication: { id: 'Komunikasi', ar: 'الاتصال' },
    academicTrack: { id: 'Jalur Akademik', ar: 'المسار الأكاديمي' },
    calibrationDate: { id: 'Tanggal Kalibrasi', ar: 'تاريخ المعايرة' },
    currentStatus: { id: 'Status Saat Ini', ar: 'الحالة الحالية' },
    adminSupport: { id: 'Dukungan Administrasi', ar: 'الدعم الإداري' },
    pendingAuthorization: { id: 'Menunggu Otorisasi', ar: 'في انتظار التفويض' },
    pendingSync: { id: 'Menunggu Sinkronisasi', ar: 'في انتظار المزامنة' },
    certProof: {
      id: 'Bukti dokumen bersertifikat elektronik.',
      ar: 'إثبات مستند معتمد إلكترونياً.',
    },
    secureTrans: {
      id: 'Protokol belajar warisan v4.2 • Transmisi Aman aktif.',
      ar: 'بروتوكول تعلم التراث v4.2 • البث الآمن نشط.',
    },
    notFound: {
      id: 'Bukti tidak ditemukan atau Anda tidak memiliki akses.',
      ar: 'الإيصال غير موجود أو لا تملك صلاحية الوصول إليه.',
    },
  },
  reflectionDetail: {
    title: { id: 'Refleksi Pembelajaran', ar: 'التأمل والتلخيص' },
    subtitle: {
      id: 'Tulis telaah kritis dan pemahaman Anda terhadap program',
      ar: 'اكتب مراجعتك وفهمك للبرنامج',
    },
    submitBtn: { id: 'Kirim Refleksi Resmi', ar: 'إرسال التأمل الرسمي' },
    draftBtn: { id: 'Simpan Draf', ar: 'حفظ كمسودة' },
    revisionNeeded: { id: 'Butuh Revisi', ar: 'بحاجة إلى مراجعة' },
    approved: { id: 'Disetujui', ar: 'مقبول' },
    redirecting: {
      id: 'Mengarahkan ke Hasil Akhir...',
      ar: 'جاري التوجيه إلى النتائج النهائية...',
    },
    submittedTitle: { id: 'Refleksi Dikirim!', ar: 'تم إرسال التأمل!' },
    submittedDesc: {
      id: 'Jazakumullahu khairan telah berbagi perjalanan Anda. Refleksi Anda telah dikirim ke mentor untuk ditinjau.',
      ar: 'جزاكم الله خيراً على مشاركة مسيرتكم. تم إرسال تأملكم إلى الموجهين للمراجعة.',
    },
    backToCurriculum: { id: 'Kembali ke Kurikulum', ar: 'العودة إلى المنهج الدراسي' },
    finalMilestone: { id: 'Pencapaian Akhir', ar: 'المرحلة النهائية' },
    reflectionIntro: {
      id: 'Alhamdulillah, Anda telah menyelesaikan seluruh materi dan evaluasi di program {name}. Sebagai langkah akhir, silakan bagikan refleksi Anda.',
      ar: 'الحمد لله، لقد أكملت جميع المواد والتقييمات في برنامج {name}. كخطوة أخيرة، يرجى مشاركة تأملك.',
    },
    reflectionPrompt: {
      id: 'Refleksi Akhir Program: Apa yang Anda dapatkan dari program ini dan bagaimana rencana Anda mengamalkannya?',
      ar: 'التأمل النهائي للبرنامج: ما الذي استفدته من هذا البرنامج وكيف تخطط لتطبيقه؟',
    },
    mainPointLabel: {
      id: 'Apa poin utama yang paling berkesan bagi Anda?',
      ar: 'ما هي النقاط الرئيسية الأكثر تأثيراً بالنسبة لك؟',
    },
    mainPointHint: {
      id: 'Tuliskan minimal 2-3 paragraf mengenai pemahaman baru atau perubahan niat yang Anda rasakan.',
      ar: 'اكتب ما لا يقل عن 2-3 فقرات حول الفهم الجديد أو التغيير في النية الذي تشعر به.',
    },
    placeholder: { id: 'Tuliskan refleksi Anda di sini...', ar: 'اكتب تأملك هنا...' },
    submitAndFinish: {
      id: 'Kirim Refleksi & Selesaikan Program',
      ar: 'إرسال التأمل وإنهاء البرنامج',
    }, // wait, 'إرسال'
    completionStatus: { id: 'Status Ketuntasan', ar: 'حالة الإكمال' },
    curriculum: { id: 'Kurikulum', ar: 'المنهج الدراسي' },
    finalExam: { id: 'Ujian Akhir', ar: 'الامتحان النهائي' },
    nextStep: { id: 'Langkah Berikutnya', ar: 'الخطوة التالية' },
    reflection: { id: 'Refleksi', ar: 'التأمل' },
    mentorNote: { id: 'Catatan Mentor', ar: 'ملاحظة الموجه' },
    mentorNoteText: {
      id: '"Refleksi adalah bagian dari menjaga keberkahan ilmu. Tuliskan apa yang benar-benar Anda rasakan dan ingin Anda amalkan."',
      ar: '"التأمل جزء من الحفاظ على بركة العلم. اكتب ما تشعر به وتود تطبيقه فعلياً."',
    },
    passed: { id: 'Lulus', ar: 'ناجح' },
    failed: { id: 'Belum Lulus', ar: 'غير ناجح' },
  },
  mediaPlayer: {
    noMedia: { id: 'Media Tidak Tersedia', ar: 'الوسائط غير متوفرة' },
    noMediaDesc: {
      id: 'Tidak ada konten media yang ditautkan ke materi ini. Silakan hubungi dukungan.',
      ar: 'لا يوجد محتوى وسائط مرتبط بهذه المادة حالياً. يرجى التواصل مع الدعم.',
    },
    loadFailed: { id: 'Gagal memuat video', ar: 'فشل تحميل الفيديو' },
    loadFailedDesc: {
      id: 'Sumber media mungkin tidak tersedia atau memerlukan otentikasi.',
      ar: 'قد يكون مصدر الوسائط غير متاح أو يتطلب مصادقة.',
    },
    browserNotSupportVideo: {
      id: 'Browser Anda tidak mendukung tag video.',
      ar: 'متصفحك لا يدعم تشغيل الفيديو.',
    },
    docResource: { id: 'Sumber Dokumen', ar: 'مصدر المستند' },
    docResourceDesc: {
      id: 'Silakan baca materi di bawah ini atau unduh salinannya.',
      ar: 'يرجى قراءة المادة أدناه أو تنزيل نسخة منها.',
    },
    openNewTab: { id: 'Buka di Tab Baru', ar: 'فتح في علامة تبويب جديدة' },
    download: { id: 'Unduh', ar: 'تنزيل' },
    previewNotAvailable: { id: 'Pratinjau tidak tersedia', ar: 'المعاينة غير متوفرة' },
    previewNotAvailableDesc: {
      id: 'Dokumen ini tidak dapat dipratinjau langsung di browser. Silakan unduh atau buka di tab baru.',
      ar: 'لا يمكن معاينة هذا المستند مباشرة في المتصفح. يرجى تنزيله أو فتحه في علامة تبويب جديدة.',
    },
    audioDisc: { id: 'Diskusi Audio', ar: 'النقاش الصوتي' },
    audioDiscDesc: {
      id: 'Dengarkan penjelasan ilmiah untuk materi ini.',
      ar: 'استمع إلى الشرح العلمي لهذه المادة.',
    },
    browserNotSupportAudio: {
      id: 'Browser Anda tidak mendukung elemen audio.',
      ar: 'متصفحك لا يدعم تشغيل الصوت.',
    },
    audioStreamUnavailable: { id: 'Aliran audio tidak tersedia', ar: 'البث الصوتي غير متوفر' },
    interactiveMaterial: { id: 'Materi Interaktif', ar: 'مادة تفاعلية' },
    interactiveMaterialDesc: {
      id: 'Materi ini dirancang untuk interaktif. Silakan gulir ke bawah untuk menyelesaikan tugas terkait.',
      ar: 'تم تصميم هذه المادة لتكون تفاعلية. يرجى التمرير لأسفل لإكمال المهام المرتبطة.',
    },
  },

  transcripts: {
    title: { id: 'Transkrip & Rapor Akademik', ar: 'كشف الدرجات والتقرير الأكاديمي' },
    subtitle: {
      id: 'Kartu hasil studi resmi, rekapitulasi nilai per mata pelajaran, dan yudisium kelulusan.',
      ar: 'بطاقة النتائج الدراسية الرسمية، وسجل الدرجات لكل مادة، والتقدير العام للتخرج.',
    },
    loading: { id: 'Memuat transkrip...', ar: 'جاري تحميل كشف الدرجات...' },
    emptyTitle: { id: 'Belum Ada Transkrip', ar: 'لا يوجد كشف درجات' },
    emptyDesc: {
      id: 'Transkrip akan tersedia setelah Anda menyelesaikan materi dan evaluasi dalam program.',
      ar: 'سيتوفر كشف الدرجات بعد إكمال المواد والتقييمات في البرنامج.',
    },
    browsePrograms: { id: 'Jelajahi Program', ar: 'تصفح البرامج' },
    semester: { id: 'Semester / Level', ar: 'الفصل / المستوى' },
    predicate: { id: 'Predikat', ar: 'التقدير' },
    totalGrades: { id: 'Nilai Total', ar: 'مجموع الدرجات' },
    percentage: { id: 'Persentase', ar: 'النسبة المئوية' },
    status: { id: 'Status', ar: 'الحالة' },
    completed: { id: 'Selesai / Lulus', ar: 'مكتمل / ناجح' },
    inProgress: { id: 'Sedang Berjalan', ar: 'قيد التنفيذ' },
    officialTranscriptTitle: {
      id: 'TRANSKRIP HASIL BELAJAR AKADEMIK',
      ar: 'كشف درجات التحصيل الأكاديمي الرسمي',
    },
    reportCardTitle: { id: 'Rapor Hasil Belajar', ar: 'تقرير نتائج التعلم' },
    officialSealNotice: {
      id: 'Dokumen ini sah dan diterbitkan resmi oleh Tarbiyah Sunnah Learning.',
      ar: 'هذه الوثيقة رسمية ومعتمدة صادرة عن تربية السنة للتعليم عن بعد.',
    },
    studentId: { id: 'Nomor Induk Peserta (NIP)', ar: 'الرقم الأكاديمي' },
    studentName: { id: 'Nama Peserta', ar: 'اسم الدارس' },
    programName: { id: 'Program Belajar', ar: 'البرنامج الدراسي' },
    completionDate: { id: 'Tanggal Kelulusan', ar: 'تاريخ التخرج' },
    gradeAverage: { id: 'Nilai Rata-rata Kumulatif (IPK)', ar: 'المعدل التراكمي العام' },
    graduationStatus: { id: 'Status Kelulusan', ar: 'حالة التخرج' },
    yudisium: { id: 'Yudisium & Predikat', ar: 'التقدير العام' },
    subjectCode: { id: 'Kode', ar: 'الرمز' },
    subjectName: { id: 'Mata Pelajaran', ar: 'المادة الدراسية' },
    sessionsCount: { id: 'Pertemuan', ar: 'اللقاءات' },
    finalScore: { id: 'Nilai Akhir', ar: 'الدرجة النهائية' },
    gradeLetter: { id: 'Huruf', ar: 'الرمز' },
    academicPredicate: { id: 'Predikat', ar: 'التقدير' },
    subjectStatus: { id: 'Status', ar: 'الحالة' },
    passed: { id: 'LULUS', ar: 'ناجح' },
    notPassed: { id: 'BELUM LULUS', ar: 'راسب' },
    inProgressStatus: { id: 'BERJALAN', ar: 'قيد الدراسة' },
    printTranscript: { id: 'Cetak Rapor / PDF', ar: 'طباعة الكشف / PDF' },
    verifyTranscript: { id: 'Verifikasi Keaslian', ar: 'التحقق من صحة الوثيقة' },
    verificationCode: { id: 'Kode Verifikasi', ar: 'رمز التحقق' },
    copiedCode: { id: 'Kode verifikasi disalin!', ar: 'تم نسخ رمز التحقق!' },
    backToResults: { id: 'Kembali ke Hasil Belajar', ar: 'العودة إلى النتائج' },
    viewCertificate: { id: 'Lihat Syahadah Kelulusan', ar: 'عرض شهادة التخرج' },
    directorSignature: {
      id: 'Pimpinan / Bagian Akademik TSL',
      ar: 'إدارة التعليم / الشؤون الأكاديمية',
    },
    viewOfficialTranscript: { id: 'Buka Transkrip Lengkap', ar: 'عرض الكشف الأكاديمي الكامل' },
    allPrograms: { id: 'Semua Program', ar: 'جميع البرامج' },

    // Legacy Transcripts Keys
    tabLmsTranscripts: { id: 'Transkrip Kurikulum Aktif (v3)', ar: 'كشف درجات المنهج الحالي (v3)' },
    tabLegacyTranscripts: {
      id: 'Histori Transkrip Program Masa Lalu',
      ar: 'أرشيف كشف الدرجات للبرامج السابقة',
    },
    currentTranscriptNavigation: { id: 'Buka Transkrip v3', ar: 'فتح كشف درجات v3' },
    legacyTranscriptNavigation: { id: 'Buka Riwayat Nilai', ar: 'فتح أرشيف الدرجات' },
    currentTranscriptContext: {
      id: 'Kurikulum aktif 6-tier',
      ar: 'المنهج الحالي بستة مستويات',
    },
    legacyArchiveContext: { id: 'Arsip sistem sebelumnya', ar: 'أرشيف النظام السابق' },
    legacyArchiveMap: { id: 'Peta riwayat belajar', ar: 'خريطة السجل الدراسي' },
    legacyArchiveMapHelp: {
      id: 'Pilih program untuk menyaring arsip. Data ini hanya untuk dibaca dan tidak mengubah capaian pada kurikulum v3.',
      ar: 'اختر البرنامج لتصفية الأرشيف. هذه البيانات للقراءة فقط ولا تغيّر إنجازات المنهج الحالي.',
    },
    clearLegacyFilters: { id: 'Reset filter', ar: 'إعادة تعيين التصفية' },
    legacyFilterResults: { id: 'Data nilai ditemukan', ar: 'سجلات الدرجات المعروضة' },
    legacyTitle: {
      id: 'Histori Transkrip Program Masa Lalu',
      ar: 'أرشيف كشف الدرجات والنتائج السابقة',
    },
    legacySubtitle: {
      id: 'Arsip riwayat capaian nilai akademik dari database sistem sebelumnya.',
      ar: 'أرشيف سجل الدرجات الأكاديمية والمعدل التراكمي من النظام السابق.',
    },
    legacyHierarchyNotice: {
      id: 'Arsip histori pembelajaran sistem lama: Nama Program > Semester > Mata Pelajaran > Nilai > Kumulatif.',
      ar: 'أرشيف سجل التعلم السابق: اسم البرنامج > الفصل > المادة الدراسية > الدرجة > المعدل التراكمي.',
    },
    activeHierarchyNotice: {
      id: 'Transkrip penilaian resmi program berjalan di LMS v3 berbasis capaian 6 Tahapan Pembelajaran.',
      ar: 'كشف التقييم الرسمي للبرنامج الحالي في LMS v3 القائم على إنجاز المراحل التعليمية الست.',
    },
    cumulativeGpa: { id: 'IPK Kumulatif Masa Lalu', ar: 'المعدل التراكمي السابق' },
    totalSemestersCompleted: { id: 'Semester Diselesaikan', ar: 'الفصول المكتملة' },
    totalCreditsLoad: { id: 'Total SKS / Beban Nilai', ar: 'إجمالي الساعات المعتمدة' },
    totalSubjectsPassed: { id: 'Mata Kuliah Lulus', ar: 'المواد المجتازة' },
    filterAllSemesters: { id: 'Semua Semester', ar: 'جميع الفصول' },
    filterSemesterPrefix: { id: 'Semester', ar: 'الفصل' },
    filterAllPrograms: {
      id: 'Semua Program / Angkatan Masa Lalu',
      ar: 'جميع البرامج / الدفعات السابقة',
    },
    searchSubjectPlaceholder: {
      id: 'Cari nama mata pelajaran atau kode...',
      ar: 'البحث عن اسم المادة أو الرمز...',
    },
    courseCode: { id: 'Kode MK', ar: 'رمز المادة' },
    courseName: { id: 'Mata Pelajaran / Mata Kuliah', ar: 'المادة الدراسية' },
    programParentName: { id: 'Program Induk', ar: 'البرنامج الدراسي' },
    creditHours: { id: 'SKS / Bobot', ar: 'الساعات' },
    numericalGrade: { id: 'Nilai Angka', ar: 'الدرجة الرقمية' },
    letterGradeCol: { id: 'Nilai Huruf', ar: 'الرمز' },
    predicateCol: { id: 'Predikat', ar: 'التقدير' },
    statusCol: { id: 'Status Kelulusan', ar: 'حالة الاجتياز' },
    semesterGpaLabel: { id: 'Indeks Prestasi Semester (IPS)', ar: 'معدل الفصل' },
    semesterCreditsLabel: { id: 'Beban SKS Semester', ar: 'ساعات الفصل' },
    printLegacyTranscript: {
      id: 'Cetak Transkrip Riwayat PDF',
      ar: 'طباعة كشف الدرجات السابق PDF',
    },
    legacyEmptyTitle: {
      id: 'Belum Ada Transkrip Riwayat Masa Lalu',
      ar: 'لا توجد سجلات درجات سابقة',
    },
    legacyEmptyDesc: {
      id: 'Akun Anda tidak memiliki data riwayat nilai dari sistem sebelumnya.',
      ar: 'لا يحتوي حسابك على بيانات درجات من النظام السابق.',
    },
    viewDetailModal: { id: 'Lihat Detail Nilai', ar: 'عرض تفاصيل الدرجة' },
    legacyOfficialDocTitle: {
      id: 'TRANSKRIP AKADEMIK RIWAYAT HASIL BELAJAR',
      ar: 'كشف الدرجات الأكاديمي للنتائج السابقة',
    },
  },

  certificates: {
    title: { id: 'Syahadah & Sertifikat', ar: 'الشهادات والإجازات' },
    subtitle: {
      id: 'Dokumen resmi kelulusan Anda dari setiap program yang telah diselesaikan.',
      ar: 'وثائق التخرج الرسمية الخاصة بك من كل برنامج أكملته.',
    },
    totalLabel: { id: 'Syahadah Tersedia', ar: 'شهادة متاحة' },
    loading: { id: 'Memuat syahadah...', ar: 'جاري تحميل الشهادات...' },
    emptyTitle: { id: 'Belum Ada Syahadah', ar: 'لا توجد شهادات بعد' },
    emptyDesc: {
      id: 'Selesaikan program untuk mendapatkan syahadah resmi kelulusan.',
      ar: 'أكمل البرنامج للحصول على شهادة التخرج الرسمية.',
    },
    browsePrograms: { id: 'Jelajahi Program', ar: 'تصفح البرامج' },
    earned: { id: 'Diperoleh', ar: 'تم الحصول عليها' },
    download: { id: 'Unduh', ar: 'تحميل' },
    downloadPdf: { id: 'Unduh Syahadah', ar: 'تحميل الشهادة' },
    unavailable: { id: 'Tidak Tersedia', ar: 'غير متاح' },
    close: { id: 'Tutup', ar: 'إغلاق' },
  },
  inactivity: {
    warningTitle: { id: 'Peringatan Sesi Tidak Aktif', ar: 'تنبيه انتهاء الجلسة بسبب عدم النشاط' },
    warningDesc: {
      id: 'Sesi Anda akan otomatis diakhiri untuk menghemat sumber daya server dalam waktu:',
      ar: 'ستنتهي جلستك تلقائيًا لتوفير موارد الخادم في غضون:',
    },
    countdownSuffix: { id: 'detik', ar: 'ثانية' },
    stayLoggedIn: { id: 'Tetap Masuk', ar: 'البقاء مسجلاً' },
    logoutNow: { id: 'Keluar Sekarang', ar: 'تسجيل الخروج الآن' },
  },
};
